import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import type { NotificacaoTesteCanal } from "@/services/api/notificacao-teste.service";

interface DestinatariosDigitadosFieldProps {
  /** Qualquer canal menos INBOX — e-mail ou telefone digitado à mão. */
  canal: Exclude<NotificacaoTesteCanal, "INBOX">;
  value: string;
  onChange: (value: string) => void;
  /** Quantos endereços o texto tem (válidos ou não). */
  total: number;
  invalidos: string[];
}

export function DestinatariosDigitadosField({
  canal,
  value,
  onChange,
  total,
  invalidos,
}: DestinatariosDigitadosFieldProps) {
  const isEmail = canal === "EMAIL";

  return (
    <div className="space-y-2">
      <Label>
        Destinatários
        {total > 0 && <span className="ml-2 text-xs text-muted-foreground">({total})</span>}
      </Label>
      <Textarea
        rows={4}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={
          isEmail ? "fulano@empresa.com\nsicrano@empresa.com" : "5511999999999\n5511888888888"
        }
      />
      <p className="text-xs text-muted-foreground">
        Um por linha (ou separados por vírgula).
        {isEmail
          ? " Ex.: nome@dominio.com"
          : " Telefone com DDI+DDD, só números, ex.: 5511999999999"}
      </p>
      {invalidos.length > 0 && (
        <p className="text-xs text-destructive">
          {isEmail ? "E-mail(s) inválido(s): " : "Telefone(s) inválido(s): "}
          {invalidos.join(", ")}
        </p>
      )}
    </div>
  );
}
